'use client';

import { ActionButton } from '@/components/ui/ActionButton';
import { BackToTop } from '@/components/ui/BackToTop';
import {
  PlanComparisonSection,
  QuoteEditMemberCard,
  useQuoteEditData,
} from './quote-edit';

export const QuoteEditStep = () => {
  const {
    members,
    pricing,
    isEditingPlan,
    setIsEditingPlan,
    locationHasPediatrics,
    savePlanChanges,
    handleAddMembers,
    handleQuote,
  } = useQuoteEditData();

  return (
    <>
      <div className='mx-auto w-full max-w-[800px] px-4 py-8 pb-[60px]'>
        <div className='flex flex-col gap-[40px]'>
          <div className='flex flex-col items-center gap-[24px] text-center xl:gap-[40px]'>
            <h1 className='font-serif text-[27px] leading-[115%] font-light text-[#292722] xl:text-[36px] xl:leading-[130%]'>
              Add coverage to your plan members.
            </h1>
            <p className='font-sans text-[18px] leading-[130%] font-normal text-[#292722] xl:text-[21px]'>
              Select a member to personalize plans.
            </p>
          </div>

          <div className='space-y-0'>
            {members.map((member, index) => (
              <div key={index}>
                <QuoteEditMemberCard
                  member={member}
                  memberIndex={index}
                  pediatricsEnabled={locationHasPediatrics}
                  pricing={
                    pricing.length > 0
                      ? pricing.find(price => price.id == index.toString())
                      : undefined
                  }
                  onPlanChange={savePlanChanges}
                  onEditingChange={setIsEditingPlan}
                />

                <div className='h-[1px] bg-[#292722]' />
              </div>
            ))}
          </div>
          <div className='flex w-full items-center'>
            <div className='grow-1 text-center'>
              <button
                onClick={handleAddMembers}
                className='sh-body cursor-pointer font-light underline'
              >
                Add or remove members
              </button>
            </div>
          </div>

          <ActionButton
            label='Update My Quote'
            variant='primary'
            type='button'
            onClick={handleQuote}
            disabled={isEditingPlan}
            className='grow-1'
          />
        </div>
      </div>

      <PlanComparisonSection />

      <div className='bg-sh-gray flex w-full flex-col items-center gap-[24px] p-[40px]'>
        <BackToTop />
      </div>
    </>
  );
};
